import {
  blue,
  green,
  grey,
  orange,
  purple,
} from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "@Pages/GenericHomePage/GenericHomePage";
import MarkEmailUnreadRoundedIcon from "@mui/icons-material/MarkEmailUnreadRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import FolderCopyRoundedIcon from '@mui/icons-material/FolderCopyRounded';
import DriveFileMoveRoundedIcon from '@mui/icons-material/DriveFileMoveRounded';

const RDCoordinatorHome = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  let sectionsBox = [
    // Incoming requests section
    {
      textBeside: "Incoming Exit Requests",
      icon: MarkEmailUnreadRoundedIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      onClick: () => navigate(DefaultRoutes.rdCoordinatorIncomingRequests),
    },
    {
      textBeside: "My Impact Assessments",
      icon: FactCheckRoundedIcon,
      iconColor: grey[600],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: grey[200],
      onClick: () => navigate(DefaultRoutes.rdCoordinatorResponses),
    },
    {
      textBeside: "Regulatory Ingredients Hub",
      icon: FolderCopyRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[100],
      onClick: () => navigate(DefaultRoutes.activeReqs),
    }
  ];

  return <GenericHomePage sectionsBox={sectionsBox} />;
};

export default RDCoordinatorHome;
